import { IdKeyType, ApiEntity, } from "./main.js";
export var BaseQueryString;
(function (BaseQueryString) {
    BaseQueryString["Token"] = "token";
    BaseQueryString["CacheControl"] = "cache-control";
})(BaseQueryString || (BaseQueryString = {}));
export var SearchQueryString;
(function (SearchQueryString) {
    SearchQueryString["Q"] = "q";
    SearchQueryString["QA"] = "qa";
    SearchQueryString["QP"] = "qp";
    SearchQueryString["F"] = "f";
    SearchQueryString["Skip"] = "skip";
    SearchQueryString["Limit"] = "limit";
    SearchQueryString["Pin"] = "pin";
})(SearchQueryString || (SearchQueryString = {}));
export var ViewBoxQueryString;
(function (ViewBoxQueryString) {
    ViewBoxQueryString["Projection"] = "projection";
    ViewBoxQueryString["Point"] = "point";
    ViewBoxQueryString["Area"] = "area";
    ViewBoxQueryString["Group"] = "group";
    ViewBoxQueryString["Margin"] = "margin";
})(ViewBoxQueryString || (ViewBoxQueryString = {}));
export var StyleQueryString;
(function (StyleQueryString) {
    StyleQueryString["StyleId"] = "style-id";
    StyleQueryString["BgColor"] = "bg-color";
    StyleQueryString["Alpha"] = "alpha";
    StyleQueryString["FeatureStyle"] = "feature-style";
    StyleQueryString["Labels"] = "labels";
    StyleQueryString["Fill"] = "fill";
    StyleQueryString["Stroke"] = "stroke";
    StyleQueryString["StrokeWidth"] = "stroke-width";
    StyleQueryString["PointRadius"] = "point-radius";
    StyleQueryString["LabelFont"] = "label-font";
    StyleQueryString["LabelFontStyle"] = "label-font-style";
    StyleQueryString["LabelColor"] = "label-color";
    StyleQueryString["LabelSize"] = "label-size";
    StyleQueryString["LabelWeight"] = "label-weight";
    StyleQueryString["LabelStroke"] = "label-stroke";
    StyleQueryString["LabelStrokeWidth"] = "label-stroke-width";
})(StyleQueryString || (StyleQueryString = {}));
export var AtlasQueryString;
(function (AtlasQueryString) {
    AtlasQueryString["Precision"] = "precision";
    AtlasQueryString["Atlas"] = "atlas";
})(AtlasQueryString || (AtlasQueryString = {}));
